module.exports = __webpack_public_path__ + "img/id-verification.8adbf3fb.png";